$(function () {

    function init() {
        init_wizard();
        init_famille();
        init_form_validate();
    }

    function init_form_validate() {
        var lang = $("html").attr("lang");
        $("#register").validate({
            ignore: [],
            lang: lang,
            invalidHandler: function (form, validator) {
                var errors = validator.numberOfInvalids();
                if (errors) {
                    notification(null, "error");
                }
            }
        });
    }

    function init_famille() {
        $(document).on("click", ".btn-clone-famille", function (e) {
            $('.clone_famille').clone().removeClass('clone_famille').appendTo('.clone_famille_conteneur');
        });
    }

    function init_wizard() {
        const toggles = document.querySelectorAll('[data-bs-toggle="wizard"]');
        const wizardtabs = document.querySelectorAll('.wizard-tab');

        toggles.forEach(toggle => {
            toggle.addEventListener('click', function (e) {
                e.preventDefault();
                var tab = new bootstrap.Tab(toggle);
                tab.show();
                wizardtabs.forEach(tab => {
                    tab.classList.remove('active');
                    var tab_active = document.querySelector('[href="' + toggle.getAttribute("href") + '"]');
                    tab_active.classList.add('active');
                });
            });
        });
    }

    init();
});
 